<template>
  <div class="gradient-row">
    <div class="Download">
      <h4>下载安装</h4>
      <h3>-----浏览器插件端-----</h3>
      <p>选择对应的浏览器，去扩展商店下载</p>
      <div class="Download-btn-row">
        <div class="Download-btn">
          <a class="extensions-row" href="https://chrome.google.com/webstore/detail/dhdelcemeednchdmijiocipbjlknndff">
            <div class="extensions"></div>
            <span class="extensions-text">Chrome 网上应用店</span>
          </a>
        </div>
        <div class="Download-btn">
          <a class="extensions-row"
            href="https://microsoftedge.microsoft.com/addons/detail/kophadiajpobbfoobhclbobddkoindoi">
            <div class="edge"></div>
            <span class="extensions-text">Edge 外接程序</span>
          </a>
        </div>
        <!-- <div class="Download-btn">
          <a class="extensions-row" href="https://addons.mozilla.org/zh-CN/firefox/addon/choose-funds/">
            <div class="add-ons"></div>
            <span class="extensions-text">附加组件</span>
          </a>
        </div> -->
      </div>

      <p style="margin-top:10px">
        若因网络问题，可以下载CRX文件手动安装<el-button style="margin-left: 10px;" type="primary" plain size="mini"
          @click="openPage('QA')">安装教程 <i class="el-icon-warning-outline"></i></el-button>
      </p>
      <div class="btn-row">
        <a href="http://github.com/x2rr/funds/releases/latest"><el-button type="primary">下载地址1</el-button></a>
        <a href="https://gitee.com/rabt/funds/releases"><el-button type="primary">下载地址2</el-button></a>
      </div>
      <h3>-----手机App端-----</h3>
      <div>{{ version.appInfo }}</div>
      <div style="display: flex;justify-content: center;padding-top: 20px;gap: 10px;">
        <div class="box">
          <div style="padding-bottom: 5px;font-size: 15px;">安卓Apk-版本{{ version.apkVer }}</div>
          <div style="padding: 5px 10px;"><a :href="version.apkLink1"><el-button type="primary">下载地址1</el-button></a>
          </div>
          <div style="padding: 5px 10px;"><a :href="version.apkLink2" target="_blank"><el-button
                type="primary">下载地址2</el-button></a>
          </div>
        </div>
        <div class="box">
          <div style="padding-bottom: 5px;font-size: 15px;">iOS商店地址</div>
          <div style="padding: 5px 10px;"><a :href="version.iosLink" target="_blank"><el-button type="primary">{{
            version.iosLink ? '点击跳转' : '敬请接待' }}</el-button></a></div>
        </div>
      </div>

      <h3>-----微信小程序端-----</h3>
      <!-- <p style="margin-top:20px">
        微信小程序‘韭菜计算助手’已上线，欢迎使用。
      </p> -->
      <div v-if="version.mpName1" style="display: flex;padding-bottom: 20px;max-width: 420px;margin: 0 auto;"
        :class="version.mpName2 ? 'space' : 'center'">
        <div style="padding: 5px 10px;">
          <div style="padding-bottom: 15px;font-size: 15px;">{{ version.mpName1 }}</div>
          <el-image style="width: 150px;height: 150px;" fit="contain" :src="version.mpImg1"></el-image>
        </div>
        <div style="padding: 5px 10px;" v-if="version.mpName2">
          <div style="padding-bottom: 15px;font-size: 15px;">{{ version.mpName2 }}</div>
          <el-image style="width: 150px;height: 150px;" fit="contain" :src="version.mpImg2"></el-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      loading: false,
      version: {},
    };
  },
  mounted() {
    this.getVersion();
  },
  methods: {
    openPage(page) {
      this.$router.push(page);
    },
    getVersion() {
      // this.version = {
      //   "appInfo": "安卓App已发布测试版，欢迎下载使用。iOS版正在走流程，敬请期待。",
      //   "apkVer": "1.0.1",
      //   "apkLink1": "https://gitee.com/rabt/funds/releases/download/3.4.3/funds-test-1.0.1.apk",
      //   "apkLink2": "https://share.feijipan.com/s/xWeCVVp7",
      //   "iosLink": "",
      //   "mpImg1": "https://github.com/x2rr/Picture/raw/master/img/mp.jpg",
      //   "mpImg2": "https://github.com/x2rr/Picture/raw/master/img/mp1.jpg",
      //   "mpName1": "韭菜计算助手",
      //   "mpName2": ""
      // }
      this.loading = true;
      let domain = window.location.host;
      // let domain = "funds.rabt.top";
      let timestamp = new Date().getTime();
      let range = 1 * 60 * 1000;
      timestamp = Math.floor(timestamp / range) * range;
      let url = "https://" + domain + "/funds/src/common/version.json?t=" + timestamp;
      this.$axios.get(url).then((res) => {
        console.log(res);
        this.loading = false;
        this.version = res.data;
      });
    },
  }
};
</script>
<style lang="scss" scoped>
.Download {
  padding: 20px;
  box-sizing: border-box;
  margin: 0 auto;

  h4 {
    font-size: 30px;
    margin: 40px 0 30px;
  }

  .btn-row {
    padding: 0 0 5px;

    &>a {
      margin: 10px;
      padding: 0 20px;

      .el-button {
        // padding: 15px 25px;
        // font-size: 17px;
        // margin: 5px 15px 10px;
      }
    }
  }

  .Download-btn-row {
    display: flex;
    padding: 0;
    justify-content: center;
    box-sizing: border-box;
    flex-wrap: wrap;

    .Download-btn {
      background: #ecf5ff;
      border: 1px solid #b3d8ff;
      border-radius: 5px;
      display: inline-block;
      height: 100px;
      width: 30%;
      min-width: 270px;
      max-width: 330px;
      line-height: 100px;
      box-sizing: border-box;
    }
  }

  .extensions-row {
    color: #666;
    align-items: center;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    justify-content: center;
    text-decoration: none;

    .edge {
      width: 108px;
      height: 23px;
      background-size: 100%;
      background-repeat: no-repeat;
      background-image: url("../assets/Microsoft.png");
    }
  }

  .extensions-text {
    padding-left: 10px;
    font-size: 18px;
  }

  .extensions {
    width: 45px;
    flex-shrink: 0;
    height: 45px;
    background-image: url("../assets/extensions.svg");
  }

  .add-ons {
    width: 155px;
    flex-shrink: 0;
    height: 36px;
    background-image: url("../assets/add-ons.svg");
    background-size: 100%;
    background-repeat: no-repeat;
  }
}

@media (min-width: 1140px) {
  .Download {
    width: 1140px;
  }

  .Download-btn {
    margin: 15px;
  }
}

@media (min-width: 480px) and (max-width: 1139px) {
  .Download {
    width: 100%;
  }

  .Download-btn {
    margin: 15px;
  }
}

@media (max-width: 479px) {
  .Download {
    width: 100%;
  }

  .Download-btn {
    margin: 10px 0;
  }
}

.box {
  border: 1px solid #fff;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px 10px;
  width: 170px;
}

.space {
  justify-content: space-between;
}

.center {
  justify-content: center;
}
</style>
